import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Pages } from "routes";
import { useAppSelector } from "store/hooks";
import { initiatePayment, loadUsersPlans, selectUserHasPlan } from "store/payments";
import {
  selectCurrentUserPlans,
  selectUserStatus,
} from 'store/user/selectors';
import { UserStatus, fetchCurrentUserPlans } from 'store/user/slice';
import { RootState } from 'store';
import { Mixpanel } from 'utils/mixpanel';

export const useRedirectToPaymentOrMyWill = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userHasPlan = useAppSelector(selectUserHasPlan);
  const currentUserPlansResponse = useAppSelector(selectCurrentUserPlans);
  const currentPlan = currentUserPlansResponse?.data?.fetchPlans?.[0];
  const userStatus = useAppSelector(selectUserStatus);
  const purchasedPlans = useAppSelector((state: RootState) => state.payments.purchasedPlans);

  return {
    redirectToPaymentOrMyWill: () => {
      const isPlansLoading = userStatus.includes(UserStatus.ACTION_SET_YELLOW_PLUS_PLAN_LOADING) &&
        !userStatus.includes(UserStatus.YELLOW_PLUS_PLAN_LOADED);

      console.log('useRedirectToPaymentOrMyWill ->', { isPlansLoading, userHasPlan, currentPlan, purchasedPlans });

      // If plans not loaded or purchasedPlans missing, trigger loads and wait
      if (isPlansLoading || !purchasedPlans) {
        // @ts-ignore
        dispatch(loadUsersPlans());
        dispatch(fetchCurrentUserPlans());
        console.log('Plans not ready; triggered load and delaying routing decision');
        return;
      }
      if (userHasPlan) {
        Mixpanel.track('Will Generated');
        (window as any).webengage.track("Generate Will Clicked",{
          "Will Generated": "yes"
        });
        dispatch(initiatePayment());
        setTimeout(() => navigate(Pages.MY_WILL), 1000);
      } else {
        if(currentPlan && currentPlan.planId !== 'yess'){
          navigate(Pages.PAYMENT + '?selectedPlans=will', { replace: true })
        } else {
          navigate(Pages.PAYMENT, { state: { fromWillEditor: true } });
        }
      }
    }
  }
}
